import { render, staticRenderFns } from "./shopCont.vue?vue&type=template&id=0aa29749&scoped=true"
import script from "./shopCont.vue?vue&type=script&lang=js"
export * from "./shopCont.vue?vue&type=script&lang=js"
import style0 from "./shopCont.vue?vue&type=style&index=0&id=0aa29749&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa29749",
  null
  
)

export default component.exports